// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2sON6";
export var container = "footer-module--container--2ewv1";
export var paragraph = "footer-module--paragraph--6U0Fd";
export var link = "footer-module--link--1tJk_";
export var socials = "footer-module--socials--3Srhn";
export var icon = "footer-module--icon--2khog";